import React, { useEffect, useState } from 'react';
import { sideMenuBasedOnRole, getSettingsSubmenu } from '../Utils/utils';
import '../styled/pages/dashboard.scss';
import { getIcon, Icon } from '@ohif/ui';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store/store';
import { logoutAndWipeBrowser, getRole } from '../Utils/authUtils';

interface SideMenuProps {
  isOpen?: boolean;
  closeSideBar?: () => void;
}

const SideMenu = ({ isOpen, closeSideBar }: SideMenuProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const [sideMenuItems, setSideMenuItems] = useState([]);
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);
  const [userRole, setUserRole] = useState<string>('');

  useEffect(() => {
    const role = getRole();
    setUserRole(role);
    setSideMenuItems(sideMenuBasedOnRole(role));
    if (getSettingsSubmenu(role).some(item => item.redirectTo === location.pathname)) {
      setOpenSubMenu('Settings');
    }
  }, [location.pathname]);

  const Logout = () => {
    void logoutAndWipeBrowser(dispatch);
  };

  const handleItemClick = (path: string) => {
    navigate(path);
  };

  if (isOpen === false) {
    return null;
  }

  return (
    <div className="layoutSidemenu">
      <div className="layoutSidemenu__logo">
        <div className="layoutSidemenu__logo__img" onClick={() => {
          if (sideMenuItems.length > 0) {
            navigate(sideMenuItems[0].path);
          }
          closeSideBar();
        }}>
          {getIcon("logo")}
        </div>
        <button
          className="btnCollapse"
          id="sidebarCollapse"
        >
          <Icon name="sidebar-chevron-left" />
        </button>
      </div>
      <div className="layoutSidemenu__fullHeight">
        <ul className="layoutSidemenu__list">
          {sideMenuItems?.map((item, index) => (
            <li
              key={index}
              className={`layoutSidemenu__list--item ${location.pathname === item.path ? 'layoutSidemenu__selected' : ''}`}
            >
              <button
                className="layoutSidemenu__list--link"
                onClick={() => {
                  handleItemClick(item.path);
                  closeSideBar();
                }}
              >
                <span className="icon">
                  <Icon name={item.icon} />
                </span>
                <span>{item.title}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SideMenu;
